(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sb-klaviyo-proxy-button"] && !Shopify.designMode) return;
  try {
    (() => {
    function forEachProxy(callback) {
      const nodes = document.querySelectorAll('.sb-klaviyo-proxy');
      nodes.forEach((node) => callback(node));
    }

    function findGroupRoot(el) {
      let node = el;
      while (node && node !== document && !node.classList?.contains('group-block')) {
        node = node.parentElement || node.host || node.parentNode;
      }
      return node && node.classList?.contains('group-block') ? node : document;
    }

    function hideKlaviyoButton(groupRoot) {
      const kBtn = groupRoot.querySelector('.sb-klaviyo-form button');
      if (kBtn) {
        kBtn.style.display = 'none';
      }
      return !!kBtn;
    }

    function clickKlaviyoButton(groupRoot) {
      const kBtn = groupRoot.querySelector('.sb-klaviyo-form button');
      if (kBtn) {
        kBtn.click();
        return true;
      }
      return false;
    }

    function setup(root) {
      forEachProxy((proxyRoot) => {
        const proxyButton = proxyRoot.querySelector('.sb-klaviyo-proxy__button');
        if (!proxyButton) return;

        const groupRoot = findGroupRoot(proxyButton);

        // Attempt to hide immediately and also observe future inserts (Klaviyo async)
        hideKlaviyoButton(groupRoot);
        const observer = new MutationObserver(() => hideKlaviyoButton(groupRoot));
        observer.observe(groupRoot, { childList: true, subtree: true });

        proxyButton.addEventListener('click', () => {
          if (clickKlaviyoButton(groupRoot)) return;
          // Retry briefly if Klaviyo content is still loading
          let attempts = 0;
          const maxAttempts = 20;
          const interval = setInterval(() => {
            attempts += 1;
            if (clickKlaviyoButton(groupRoot) || attempts >= maxAttempts) {
              clearInterval(interval);
            }
          }, 150);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup(document));
    } else {
      setup(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sb-klaviyo"] && !Shopify.designMode) return;
  try {
    (() => {
    const processedInputs = new WeakSet();
    const processedForms = new WeakSet();

    function trimInput(input) {
      if (!input.value) return;
      
      const trimmed = input.value.trim();
      if (input.value !== trimmed) {
        input.value = trimmed;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    function setupInput(input) {
      if (processedInputs.has(input)) return;
      processedInputs.add(input);
      
      input.addEventListener('blur', () => trimInput(input), { passive: true });
    }

    function setupForm(form) {
      if (processedForms.has(form)) return;
      processedForms.add(form);

      // Setup existing inputs
      form.querySelectorAll('input[type="text"], input[type="email"], textarea')
        .forEach(setupInput);

      // Handle form submission
      form.addEventListener('submit', (e) => {
        form.querySelectorAll('input[type="text"], input[type="email"], textarea')
          .forEach(trimInput);
      }, { passive: true });
    }

    // Single observer for all dynamic content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          // Check if node itself is a form or input
          if (node.matches?.('.sb-klaviyo-form form')) {
            setupForm(node);
          } else if (node.matches?.('.sb-klaviyo-form form input[type="text"], .sb-klaviyo-form form input[type="email"], .sb-klaviyo-form form textarea')) {
            setupInput(node);
          }

          // Check descendants
          node.querySelectorAll?.('.sb-klaviyo-form form').forEach(setupForm);
          node.querySelectorAll?.('.sb-klaviyo-form form input[type="text"], .sb-klaviyo-form form input[type="email"], .sb-klaviyo-form form textarea').forEach(setupInput);
        });
      });
    });

    // Initialize
    document.querySelectorAll('.sb-klaviyo-form form').forEach(setupForm);
    
    // Start observing
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup on page unload (if using view transitions)
    if ('navigation' in window) {
      navigation.addEventListener('navigate', () => observer.disconnect());
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
